import { css } from "@emotion/react";

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const rowContainer = css`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const gateAccessContainer = css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const openSeaLink = css`
  text-decoration: none;

  @media (hover: hover) {
    &:hover {
      text-decoration: none;
    }
  }
`;
